import { Card } from "primereact/card";
import Container from "../../../../../vendors/components/Container";
import Field from "../../../../../vendors/components/Field";
import { InputText } from "primereact/inputtext";
import AnttDropdown from "../../../../../vendors/components/Dropdown";
import AnttCalendar from "../../../../../vendors/components/Calendar";
import ConsultaButtons from "../../../../../vendors/components/ConsultaButtons";
import React, { useEffect, useRef, useState } from "react";
import ConsultarEventosController from "../controller/consultar-eventos.controller";
import { Paginator } from "primereact/paginator";
import { EventoOrdenacaoConstants } from "../../../../shared/utils/EventoOrdenacaoConstants";
import ModalLogin from "../../../../components/modal-login";
import { OverlayPanel } from "primereact/overlaypanel";
import { ShareModal } from "../../../../components/ShareModal/ShareModal";
import { ConsultarEventosConstants } from "../utils/ConsultarEventosConstants";
import {
  dataParaIso,
  isoParaData,
  salvarCampoFiltro,
} from "../utils/filterStorage";
import EventoResultadoItem from "../components/EventoResultadoItem";
import { idDoEvento } from "../../../../shared/utils/EventoInternoUtil";

export default function ConsultarEventos() {
  const controller = new ConsultarEventosController();
  const filter = controller.filter;
  const ordenacaoList = EventoOrdenacaoConstants.LISTA;
  const agendaRegulatoriaList = ConsultarEventosConstants.AGENDA_REGULATORIA_LISTA;
  const shareModalRef = useRef<OverlayPanel>(null);
  const [currentShareUrl, setCurrentShareUrl] = useState("");

  useEffect(() => {
    controller.init();
  }, []);

  const click = (row: any) => {
    controller.abrirEvento(row);
  };

  const compartilhar = async (row: any, e: React.MouseEvent) => {
    const link = await controller.getEvento(idDoEvento(row));
    setCurrentShareUrl(link);
    shareModalRef.current?.toggle(e);
  };

  return (
    <>
      <Card title="Consultar Eventos">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            controller.setLazyParams({
              ...controller.lazyParams,
              page: 0,
              first: 0,
            });
            controller.consultar();
          }}
        >
          <Container>
            <Field label="Busca" col={12}>
              <InputText
                maxLength={100}
                placeholder="Digite uma palavra-chave para pesquisa no campo objeto (ex: BR-153, frete…)"
                value={filter.busca}
                onChange={(e) => {
                  filter.setBusca(e.target.value);
                  salvarCampoFiltro("busca", e.target.value);
                }}
              />
            </Field>
            <Field label="Recebimento de contribuição" col={6}>
              <div className="consultar-eventos-datas">
                <div className="consultar-eventos-datas-item">
                  <label className="consultar-eventos-datas-subtitulo">Início</label>
                  <AnttCalendar
                    showIcon
                    placeholder="dd/mm/aaaa"
                    value={isoParaData(filter.recebimentoDeContribuicaoInicial) || undefined}
                    onChange={(e) => {
                      const valor = dataParaIso(e.value as Date);
                      filter.setRecebimentoDeContribuicaoInicial(valor);
                      salvarCampoFiltro(
                        "recebimentoDeContribuicaoInicial",
                        valor
                      );
                    }}
                  />
                </div>
                <div className="consultar-eventos-datas-item">
                  <label className="consultar-eventos-datas-subtitulo">Encerramento</label>
                  <AnttCalendar
                    showIcon
                    placeholder="dd/mm/aaaa"
                    minDate={
                      isoParaData(filter.recebimentoDeContribuicaoInicial) ||
                      undefined
                    }
                    value={isoParaData(filter.recebimentoDeContribuicaoFinal) || undefined}
                    onChange={(e) => {
                      const valor = dataParaIso(e.value as Date);
                      if (
                        filter.recebimentoDeContribuicaoInicial &&
                        valor &&
                        valor < filter.recebimentoDeContribuicaoInicial
                      ) {
                        return;
                      }
                      filter.setRecebimentoDeContribuicaoFinal(valor);
                      salvarCampoFiltro("recebimentoDeContribuicaoFinal", valor);
                    }}
                  />
                </div>
              </div>
            </Field>
            <Field
              label="Evento da Agenda Regulatória"
              col={6}
              className="consultar-eventos-agenda"
            >
              <AnttDropdown
                options={agendaRegulatoriaList}
                optionLabel="label"
                optionValue="value"
                filter={false}
                showClear={false}
                value={filter.stAgendaRegulatoria}
                onChange={(e) => {
                  const valor =
                    e.value || ConsultarEventosConstants.AGENDA_AMBOS;
                  filter.setStAgendaRegulatoria(valor);
                  salvarCampoFiltro("stAgendaRegulatoria", valor);
                }}
              />
            </Field>
            <Field label="Número" col={3}>
              <InputText
                value={filter.numeroAudiencia}
                onChange={(e) => {
                  const digitos = (e.target.value || "").replace(/\D/g, "");
                  if (digitos.length > 9) {
                    return;
                  }
                  filter.setNumeroAudiencia(e.target.value);
                  salvarCampoFiltro("numeroAudiencia", e.target.value);
                }}
              />
            </Field>
            <Field label="Ano" col={3}>
              <AnttDropdown
                options={controller.anoList}
                optionLabel="descricao"
                optionValue="codigo"
                filterBy="descricao"
                value={filter.codigoAno}
                onChange={(e) => {
                  filter.setCodigoAno(e.value);
                  salvarCampoFiltro("codigoAno", e.value);
                }}
              />
            </Field>
            <Field label="Tipo de Evento" col={3}>
              <AnttDropdown
                options={controller.tipoEventoList}
                optionLabel="dsTpEvento"
                optionValue="cdTpEvento"
                filterBy="dsTpEvento"
                value={filter.codigoTipoEvento}
                onChange={(e) => {
                  filter.setCodigoTipoEvento(e.value);
                  salvarCampoFiltro("codigoTipoEvento", e.value);
                }}
              />
            </Field>
            <Field label="Situação" col={3}>
              <AnttDropdown
                options={controller.situacaoList}
                optionLabel="descricao"
                optionValue="codigo"
                filterBy="descricao"
                value={filter.codigoSituacao}
                onChange={(e) => {
                  filter.setCodigoSituacao(e.value);
                  salvarCampoFiltro("codigoSituacao", e.value);
                }}
              />
            </Field>
          </Container>
          <Container>
            <ConsultaButtons
              permissaoConsultar=""
              limpar={() => controller.limpar()}
            />
          </Container>
        </form>
      </Card>
      <Card className="ce-resultados">
        <div className="ce-resultados-topo">
          <div>
            <h2 className="ce-resultados-titulo">Consultar Eventos</h2>
            <span className="ce-resultados-total">
              {controller.total} {controller.total === 1 ? "evento encontrado" : "eventos encontrados"}
            </span>
          </div>
          <div className="ce-ordenar">
            <label htmlFor="ordenar-eventos">Ordenar por</label>
            <AnttDropdown
              inputId="ordenar-eventos"
              options={ordenacaoList}
              showClear={false}
              optionLabel="label"
              optionValue="value"
              value={filter.ordering}
              placeholder="Organizar por"
              onChange={(e) => {
                filter.setOrdering(e.value);
                salvarCampoFiltro("ordering", e.value);
                controller.setLazyParams({
                  ...controller.lazyParams,
                  page: 0,
                  first: 0,
                });
                controller.consultar(0, 10, null, e.value);
              }}
            />
          </div>
        </div>
        {controller.lista.length > 0 && (
          <div className="ce-colunas">
            <span>Evento</span>
            <span>Objeto</span>
            <span>Situação do evento</span>
            <span>Ações</span>
          </div>
        )}
        <div className="ce-lista">
          {controller.lista.map((evento: any, index: number) => (
            <EventoResultadoItem
              key={`consultar-evento-${evento.id || evento.codAudienciaPublica || index}`}
              evento={evento}
              onAcessar={click}
              onCompartilhar={compartilhar}
            />
          ))}
          {controller.lista.length <= 0 && (
            <div className="ce-vazio">
              <i className="pi pi-inbox" />
              <span>Nenhum registro encontrado</span>
            </div>
          )}
        </div>
        <div className="ce-paginacao">
          <div className="ce-paginacao-item">
            <Paginator
              rows={controller.lazyParams.rows}
              first={controller.lazyParams.first}
              totalRecords={controller.total}
              onPageChange={(e: any) => controller.onPage(e)}
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
            />
          </div>
        </div>
        <ShareModal ref={shareModalRef} url={currentShareUrl} />
      </Card>
      <ModalLogin
        visible={controller.visibleLogin}
        dispositivoLogin={{}}
        onHide={() => controller.setVisibleLogin(false)}
      />
    </>
  );
}
